import React from 'react';
import TourProvider, { TourStep } from '../tours/TourProvider';

interface StudentDashboardTourWrapperProps {
  toursSeen: string[];
  isSelfPaced: boolean;
  markTourAsSeenUrl: string;
  translations: {
    current_project?: string;
    your_level?: string;
    upcoming_events?: string;
    progress?: string;
    current_projects?: string;
  };
}

const StudentDashboardTourWrapper: React.FC<StudentDashboardTourWrapperProps> = ({
  toursSeen,
  isSelfPaced,
  markTourAsSeenUrl,
  translations,
}) => {
  const steps: TourStep[] = isSelfPaced
    ? [
        {
          selector: '.panel.panel-tile.summary-card',
          content: translations.current_project || 'This is your current project. Once it\'s finished, a new one will appear here.',
        },
        {
          selector: '#student-home-level-card',
          content: translations.your_level || 'When you finish a project, depending on the difficulty, it will change this graph showing your level progress.',
        },
        {
          selector: '#student-home-events-card',
          content: translations.upcoming_events || 'You can see here activities of your cohort - upcoming events you can attend.',
        },
        {
          selector: '#student-home-progress-card',
          content: translations.progress || 'This is the pathway of your current program. You can see all projects and your progress through them.',
        },
      ]
    : [
        {
          selector: '.panel.panel-default:has(.panel-title)',
          content: translations.current_projects || 'These are your current projects. Once you finish them, new ones will appear here.',
        },
        {
          selector: '#student-home-events-card',
          content: translations.upcoming_events || 'You can see here activities of your cohort - upcoming events you can attend.',
        },
      ];

  return <TourProvider tourKey="dashboard" steps={steps} toursSeen={toursSeen} markTourAsSeenUrl={markTourAsSeenUrl} />;
};

export default StudentDashboardTourWrapper;

